import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col} from "antd";
import DBRiskControlForm from "./forms/db-risk-control-form";
import {
    STATE_STATUS,
} from "./constants";
import { fetchDbRiskControlDetail, updateDbRiskControlDetail } from "./actions"

class DBRiskControl extends React.Component {

    formRef = React.createRef();
    componentDidMount() {
        this.props.fetchDbRiskControlDetail(this.props.companyId);
    }

    onValuesSubmit = (data, requestType) => {
        this.props.updateDbRiskControlDetail(this.props.companyId, data, requestType)
    }

    getLoading() {
        const status = this.props.profile && this.props.profile.get("status");
        if (status === STATE_STATUS.UPDATING || status === STATE_STATUS.FETCHING) {
            return true;
        }
        return false;
    }
    render() {
        return <Row>
            
            <Col span={18} offset={3}>
                <DBRiskControlForm
                    ref={this.formRef}
                    onValuesSubmit={this.onValuesSubmit}
                    dbRiskFormDetail={this.props.dbRiskFormDetail}
                    dbRiskFormDetailStatus={this.props.dbRiskFormDetailStatus}
                    loading={this.getLoading()}
                    disableFields={false}
                    companyId={this.props.companyId}
                    profile={this.props.profile}
                />
            </Col>
        </Row>;
    }
}


DBRiskControl.propTypes = {
    companyId: PropTypes.string,
    profile: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const { match: { params } } = props;
    return {
        dbRiskFormDetail: state.companyLosProfiles.getIn(['db_risk_control_details', props.companyId, 'data']),
        dbRiskFormDetailStatus: state.companyLosProfiles.getIn(['db_risk_control_details', props.companyId, 'status']),
    }
}


const mapDispatchToProps = dispatch => bindActionCreators({
        fetchDbRiskControlDetail,
        updateDbRiskControlDetail
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DBRiskControl);